export function openLinksInNewTab(html) {
  let tmp = document.implementation.createHTMLDocument("New").body
  tmp.innerHTML = html
  tmp.querySelectorAll('a').forEach(function(node){
    node.setAttribute('target', '_blank')
  })
  return tmp.innerHTML
}
